import { CategoryInfo } from '@components/detailFilter/lib/categoryInfo';
import { DetailFilterItem } from '@components/detailFilter/lib/detailFilterItem';
import { cn } from '@utils/helpers';
import { InfoIcon } from 'lucide-react';
import { useCallback, useState } from 'react';
import { useFragment } from 'react-relay';
import { languagePreferenceFragment } from './LanguagePreference.relay';
import type { LanguagePreferencePropsType } from './types';

const LanguagePreference: React.FC<LanguagePreferencePropsType> = (props) => {
  const component = useFragment(languagePreferenceFragment, props.component);

  const [infoVisible, setInfoVisible] = useState(false);

  const toggleInfo = useCallback((): void => {
    setInfoVisible((prev) => !prev);
  }, []);

  const closeInfo = useCallback((): void => {
    setInfoVisible(false);
  }, []);

  const aggregateFilterVals = useCallback(
    (label: string, filterVal: string) => {
      props.preferredLanguageHandler(filterVal);
    },
    [props.preferredLanguageHandler],
  );

  const showCategoryName = component.categoryname || component.info;

  return (
    <div className="grid grid-cols-1 desktop:grid-cols-[1fr_3fr] gap-2 px-0">
      {showCategoryName ? (
        <div className="flex items-center flex-1 gap-2">
          <span>{component.categoryname}</span>
          {component.info ? <InfoIcon onClick={toggleInfo} className={cn('w-5 h-5 text-gray-400 hover:cursor-pointer', infoVisible && 'fill-accent text-white')} strokeWidth={1} /> : null}
        </div>
      ) : null}
      <div className="flex gap-1 max-[600px]:flex-col max-[600px]:gap-0">
        {component.items.map((item) => (
          <DetailFilterItem
            key={item.label}
            filterHandlerFn={aggregateFilterVals}
            inputGroupName="Language-Selector"
            filterItem={item}
            isRadio={true}
            selected={item.filtervalue.toUpperCase() === props.selected.toUpperCase()}
          />
        ))}
      </div>
      {showCategoryName && component.info ? <CategoryInfo info={component.info} close={closeInfo} visible={infoVisible} /> : null}
    </div>
  );
};

export { LanguagePreference };
